import React, { useState, useEffect } from "react";
import Title from "../Title/Title";
import Product from "../../components/Product";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "../../apiCalls/product";

const NewProducts = ({ cat, filters, sort }) => {
  const dispatch = useDispatch();
  const productList = useSelector((state) => state.products.products);

  const [products, setProducts] = useState(productList);

  useEffect(() => {
    fetchProducts(dispatch);
  }, [dispatch]);



  return (
    <>
      <section className="new-products">
        <Title title="New Products" />
        <div className="product-list">
          <div className="product-grid">
            {products.slice(0, 9).map((item, index) => (
              <Product item={item} key={index} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default NewProducts;
